var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.106 9.0625L4.93725 11.8938C6.09975 13.0563 7.98725 13.0563 9.156 11.8938L11.8998 9.15C13.0623 7.9875 13.0623 6.1 11.8998 4.93125L9.06225 2.10625C8.4685 1.5125 7.64975 1.19375 6.81225 1.2375L3.68725 1.3875C2.43725 1.44375 1.4435 2.4375 1.381 3.68125L1.231 6.80625C1.1935 7.65 1.51225 8.46875 2.106 9.0625Z",
    stroke: "#758CA5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 7C6.30044 7 7 6.30044 7 5.4375C7 4.57455 6.30044 3.875 5.4375 3.875C4.57456 3.875 3.875 4.57455 3.875 5.4375C3.875 6.30044 4.57456 7 5.4375 7Z",
    stroke: "#758CA5",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.e3552c580330bda57664b83af271e8b4.svg";
export { ForwardRef as ReactComponent };